const styles = {
    paddingX: "sm:px-36 px-6",
    paddingY: "sm:py-16 py-6",
    padding: "sm:px-16 px-6 sm:py-16 py-10",
  
    heroHeadText:
      "font-black text-[black] lg:text-[60px] sm:text-[40px] xs:text-[30px] text-[20px] lg:leading-[98px] mt-2",
    heroSubText:
      "text-[black] font-medium lg:text-[22px] sm:text-[20px] xs:text-[18px] text-[18px] lg:leading-[40px]",
  
    sectionHeadText:
      "text-[#4477CE] font-[#4477CE] md:text-[50px] sm:text-[40px] xs:text-[30px] text-[30px]",
    sectionSubText:
      "sm:text-[18px] text-[14px] text-black uppercase tracking-wider",
      sectionText:
      "text-[black] font-black md:text-[60px] sm:text-[50px] xs:text-[40px] text-[30px]",
    iconsText:
      " md:text-[40px] sm:text-[30px] xs:text-[30px] text-[25px]  hover:text-[black]",
    contactText:
    "text-[black]  md:text-[50px] sm:text-[35px] xs-text:[30px] text-[30px]",
    buttontext:
    "bg-[#4477CE]  cursor-pointer hover:bg-[#1b1919] hover:text-[white]"
  };
  
  export { styles };
